import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '@htx/environment';
import {
  UseCaseParticipationRequest,
  UseCaseParticipationComment
} from './use-case-participation.model';

@Injectable({
  providedIn: 'root'
})
export class UseCaseParticipationService {

  private httpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.backendUrl}/use-cases`;

  getMyStatus(useCaseSlug: string): Observable<UseCaseParticipationRequest | null> {
    return this.httpClient.get<UseCaseParticipationRequest>(
      `${this.baseUrl}/${useCaseSlug}/participation/status`,
      { observe: 'response' }
    ).pipe(
      map((response: HttpResponse<UseCaseParticipationRequest>) =>
        response.status === 204 ? null : response.body
      )
    );
  }

  requestParticipation(useCaseId: string): Observable<UseCaseParticipationRequest> {
    return this.httpClient.post<UseCaseParticipationRequest>(
      `${this.baseUrl}/${useCaseId}/participation`, {}
    );
  }

  findAll(): Observable<UseCaseParticipationRequest[]> {
    return this.httpClient.get<UseCaseParticipationRequest[]>(
      `${this.baseUrl}/participation`
    );
  }

  getDetailsById(id: string): Observable<UseCaseParticipationRequest> {
    return this.httpClient.get<UseCaseParticipationRequest>(
      `${this.baseUrl}/participation/${id}`
    );
  }

  approve(id: string, reasoning: string): Observable<void> {
    return this.httpClient.put<void>(
      `${this.baseUrl}/participation/${id}/approve`,
      { reasoning }
    );
  }

  reject(id: string, reasoning: string): Observable<void> {
    return this.httpClient.put<void>(
      `${this.baseUrl}/participation/${id}/reject`,
      { reasoning }
    );
  }

  getComments(id: string): Observable<UseCaseParticipationComment[]> {
    return this.httpClient.get<UseCaseParticipationComment[]>(
      `${this.baseUrl}/participation/${id}/comments`
    );
  }

  addComment(id: string, comment: { text: string }): Observable<UseCaseParticipationComment> {
    return this.httpClient.post<UseCaseParticipationComment>(
      `${this.baseUrl}/participation/${id}/comments`,
      comment
    );
  }
}
